import { useState } from "react";
import "./FAQScreen.css";

export default function FAQScreen() {

    const faqs = [
        {
            q: "How will it help me?",
            a: "It contains real interview questions collected from candidates and interviewers across startups and top tech companies in Bangalore. The explanations are detailed and practical, helping you understand how to think like interviewers."
        },
        {
            q: "How many total interview tests and questions are included in a pack?",
            a: "Each pack contains 10 complete interview tests, with a total of approximately 200 to 300 questions depending on the domain and difficulty level."
        },
        {
            q: "What is the refund policy?",
            a: "If no test attempt is made, you are eligible for a refund (excluding platform and payment gateway fees). Once a test is attempted, refunds are not possible."
        },
        {
            q: "What is the test duration?",
            a: "There is no fixed time limit. However, we recommend completing it within 45 minutes since real interviews generally last around that duration."
        },
        {
            q: "When can I attempt the test?",
            a: "Anytime at your convenience within the validity period."
        },
        {
            q: "Can I reattempt the test?",
            a: "No. Each interview test can be attempted only once, similar to real interview conditions."
        },
        {
            q: "Can I go back to the previous question?",
            a: "No. Like real interviews, once you move forward, you cannot come back."
        },
        {
            q: "Do I get answers?",
            a: "Yes, you will receive a detailed explanation along with your score after completing the test."
        },
        {
            q: "Can I copy or share the test questions?",
            a: "No. Copying, selling, or redistributing the questions is strictly prohibited and illegal."
        },
        {
            q: "What payment method do you use?",
            a: "Payments are handled through Razorpay, a 100% secure and trusted payment gateway."
        },
        {
            q: "What is the test validity?",
            a: "Most tests have a validity of 90 days from the date of purchase."
        },
        {
            q: "Do I get a certificate after completion?",
            a: "No, this platform is not for certification. It is meant purely for interview preparation."
        },

        // EXTRA FAQs (added for more professionalism)
        {
            q: "Can I use it on mobile and laptop?",
            a: "Yes, the platform works well on both mobile and desktop. However, we strongly recommend using a laptop for the best experience, especially because coding questions are difficult to attempt on mobile."
        },
        {
            q: "Are there domain-specific tests?",
            a: "Yes, tests are available per domain such as Android, Web, Backend, Data Science, QA Automation, and more."
        },
        {
            q: "Do the questions get updated?",
            a: "Yes. We regularly add new interview questions based on fresh interviews happening in top companies."
        }
    ];

    const [openIndex, setOpenIndex] = useState(null);

    const toggle = (i) => {
        setOpenIndex(openIndex === i ? null : i);
    };

    return (
        <div className="faq-page">
            <h1 className="faq-title">Frequently Asked Questions</h1>
            <p className="faq-subtitle">Everything you need to know about our interview tests</p>

            <div className="faq-card">
                {faqs.map((item, index) => (
                    <div key={index} className="faq-item">
                        <div className="faq-question" onClick={() => toggle(index)}>
                            <span>{item.q}</span>
                            <span className="faq-icon">{openIndex === index ? "−" : "+"}</span>
                        </div>

                        {openIndex === index && (
                            <div className="faq-answer">
                                {item.a}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
